var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "check-list" },
    [
      _c(
        "b-form-checkbox-group",
        {
          model: {
            value: _vm.checked,
            callback: function ($$v) {
              _vm.checked = $$v
            },
            expression: "checked",
          },
        },
        [
          _c(
            "ul",
            { staticClass: "list-items" },
            _vm._l(_vm.items, function (item, index) {
              return _c(
                "li",
                { key: index, staticClass: "item" },
                [
                  _c(
                    "b-form-checkbox",
                    { attrs: { value: item, "unchecked-value": "" } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("deDash")(item)) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }